<template>
  <div class="simple-page">
    <simple-page-header
        v-if="headerVisible"
        :header="header"
        :backable="backable"
        :help-text="helpText"
        :help-url="helpUrl"
        @help-click="helpClick"
        fixed>
      <template #header v-if="$slots.header">
        <slot name="header"></slot>
      </template>
      <slot name="buttons"></slot>
    </simple-page-header>
    <div class="flex-container">
      <div class="flex-container-left" v-if="$slots.west">
        <div class="flex-container-left-fixed" :style="{height: headerVisible ? 'calc(100vh - 46px)' : '100vh'}">
          <slot name="west"></slot>
        </div>
      </div>
      <div class="page-body" :style="{height: headerVisible ? 'calc(100vh - 46px)' : '100vh'}">
        <div class="page-body-query" v-if="$slots.form">
          <div class="page-body-query-form">
            <div class="page-body-query-form-left">
              <slot name="form"></slot>
              <slot name="formMore" v-if="queryExpanded"></slot>
            </div>
            <div class="page-body-query-form-right">
              <btn-search @click="query"></btn-search>
              <btn-reset @click="resetForms" v-if="queryExpanded"></btn-reset>
            </div>
          </div>
          <el-divider v-if="$slots.formMore">
            <el-link :underline="false" @click="queryExpanded=!queryExpanded">
              <i class="fa fa-angle-up" v-if="queryExpanded"></i>
              <i class="fa fa-angle-down" v-else></i>
              {{queryExpanded?"收起":"更多条件"}}
            </el-link>
          </el-divider>
        </div>
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
import BaseVue from "@/components/base/BaseVue";
import SimplePageHeader from "@/components/page/SimplePageHeader.vue";
import BtnSearch from "@/components/btns/BtnSearch.vue";
import BtnRefresh from "@/components/btns/BtnRefresh.vue";
import BtnReset from "@/components/btns/BtnReset.vue";

export default {
  name: "SimplePage",
  extends: BaseVue,
  components: {BtnReset, BtnRefresh, BtnSearch, SimplePageHeader},
  props: {
    /**
     * 左侧列表宽度
     */
    westWidth: {
      required: false,
      type: Number,
      default: 0
    },
    headerVisible: {
      type: Boolean,
      default: true
    },
    header: {
      type: String,
      required: false
    },
    helpText: {
      type: String,
      required: false
    },
    helpUrl: {
      type: String,
      required: false
    },
    backable: {
      type: Boolean,
      default: false
    }
  },
  data(){
    return {
      queryExpanded: false
    }
  },
  methods: {
    query() {
      this.$emit("query");
    },
    resetForms() {
      this.$emit("reset");
    },
    helpClick() {
      console.log("2");
      this.$emit("help-click");
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/css/variables";
.simple-page{
  .flex-container {
    display: flex;
    align-items: stretch;
    &-left {
      border-right: 1px solid $color-border-primary;
      &-fixed {
        //height: calc(100vh - 46px);
        overflow-y: auto;
        overflow-x: hidden;
        padding: 10px;
        position: sticky;
        top: 48px;
      }
      &-fixed::-webkit-scrollbar {
        width : 0;
      }
    }
    .page-body {
      //min-height: calc(100vh - 46px);
      position: relative;
      padding: 20px;
      width: 100%;
      overflow-x: hidden;
      &-query {
        &-form {
          display: flex;
          align-items: flex-start;
          //justify-content: space-around;
          &-left {
            flex-grow: 1;
            padding-right: 10px;
            .el-form::v-deep{
              .el-form-item {
                margin-bottom: 10px;
              }
            }
          }
          &-right {
            padding-left: 10px;
            flex-shrink: 0;
            .el-button{
              display: block;
              margin: 0 0 10px 0;
            }

          }
        }
      }
      .el-divider{
        margin: 12px 0 18px 0;
        height: 0.5px;
        .el-link{
          font-size: 12px;
        }
      }
    }
  }
}
</style>
